import Vue from 'vue'
import axios from "axios";

import Ticket from "./Ticket";
import Order from "./Order";
import Companies from "./Companies";
import Task from "./Task";
import Service from "./Service";
import ColdClients from "./ColdClients";
import Regions from "./Regions";

const factories = {
  ticket: Ticket(axios),
  order: Order(axios),
  companies: Companies(axios),
  task: Task(axios),
  service: Service(axios),
  coldClients: ColdClients(axios),
  regions: Regions(axios),
}

Vue.prototype.$api = factories;
